import { CloseIcon } from 'components/icons/CloseIcon';
import { TickIcon } from 'components/icons/TickIcon';

interface ITrimAlert {
  onCancel: () => void;
  onSave?: () => void;
  details?: any;
  success?: boolean;
}

export default function TrimAlert({ onCancel, onSave, details, success }: ITrimAlert) {
  return (
    <div className="transparent font-lato">
      <div className="relative border-x border-t bg-gray-bg-dark border-gray-300  bg-white pb-7 pt-9 px-7 w-screen md:w-[520px] md:min-h-[100px] rounded-t-lg">
        <div className="flex mb-5 items-center">
          <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">
            {success ? 'Trim and cut updated' : 'Trim and cut not updated'}
          </span>
          <div className="bg-red-main rounded-full ml-2 w-5 h-5 flex items-center justify-center">
            {success ? (
              <TickIcon className="fill-white w-3 h-4" />
            ) : (
              <CloseIcon className="fill-white w-4 h-4" color="white" />
            )}
          </div>
        </div>
        {success ? (
          <p>Video is being edited.</p>
        ) : (
          <p>
            {details?.status === 'started'
              ? `Video cannot be edited while video is being ${
                  details.status_type === 'processing' ? 'processed' : 'edited'
                }.`
              : details?.status === 'pending'
              ? 'Video files are not available.'
              : 'Video cannot be edited since video could not be processed.'}
          </p>
        )}
      </div>
      <div className="flex text-[13px] pb-6 px-4 bg-white rounded-b-lg border-x">
        <button
          className="bg-red-main py-3 px-12 text-white rounded-[10px] ml-auto"
          onClick={() => {
            if (onSave) {
              onSave();
            }
            onCancel();
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
}
